import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import { setDocumentTitle } from "~/lib/commonUtils";

export type FindingsPageProps = {};

export function FindingsPage({}: FindingsPageProps) {
  setDocumentTitle("Findings");

  return (
    <Box>
      <Outlet />
    </Box>
  );
}
